import { useCurrentUser } from '@root/query'

const HTTP_UNAUTHORIZED = 401

export const useIsAuthenticated = (): boolean | undefined => {
  const { isSuccess, error } = useCurrentUser({
    throwOnError(error) {
      // Unauthorized user is not an error in this context.
      // We want to handle it gracefully by showing a login page.
      if ((error as any)?.status === HTTP_UNAUTHORIZED) {
        return false
      }
      return true
    }
  })

  if (isSuccess) {
    return true
  }

  if ((error as any)?.status === HTTP_UNAUTHORIZED) {
    return false
  }

  return undefined
}
